import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

type IProps = Immutable<{
    formTitle: string;
}>;

export const WriteReviewFormHeader = (props: IProps): React.JSX.Element => {
    return (
        <div className="write-review-form__header">
            <h2 className="write-review-form__title">{props.formTitle}</h2>
            <p className="write-review-form__sub-title">
                (<span className="write-review-form__sub-title--red">*</span>){" "}
                <span className="write-review-form__sub-title--italic">
                    {t`indicates a required field`}
                </span>
            </p>
        </div>
    );
};
